
interface ServiceCardProps {
  service: {
    icon: string;
    title: string;
    description: string;
    features: string[];
    results: string;
    caseStudy: string;
  };
}

export default function ServiceCard({ service }: ServiceCardProps) {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow">
      <div className="w-16 h-16 bg-[#2BB6A3] rounded-full flex items-center justify-center mb-6">
        <i className={`${service.icon} text-2xl text-white`}></i>
      </div>
      
      <h3 className="text-2xl font-bold text-[#1B365D] mb-4">{service.title}</h3>
      <p className="text-gray-600 mb-6">{service.description}</p>
      
      <div className="mb-6">
        <h4 className="font-semibold text-[#1B365D] mb-3">Key Features:</h4>
        <ul className="space-y-2">
          {service.features.map((feature, index) => (
            <li key={index} className="flex items-start">
              <i className="ri-check-line text-[#2BB6A3] mr-2 mt-1"></i>
              <span className="text-gray-600">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="border-t pt-6">
        <div className="bg-[#2BB6A3]/10 rounded-lg p-4 mb-4">
          <div className="font-semibold text-[#1B365D] mb-1">Typical Results:</div>
          <div className="text-[#2BB6A3] font-bold">{service.results}</div>
        </div>
        
        <div className="text-sm text-gray-600 italic">
          Case Study: {service.caseStudy}
        </div>
      </div>
    </div>
  );
}
